'use strict'
import InputError from '../../lib/InputError';
import Failed from '../../lib/Failed';

class Recover {
    
    constructor(options) {
        var self=this;
        grecaptcha.enterprise.ready(async () => {
            self.recaptcha_token = await grecaptcha.enterprise.execute(options.access_key, {action: 'LOGIN'});
        });
    }

    init () {
        var self=this;

        $('#field_tipo_documento').hide();
        $('#field_pais').hide();
        $('#field_extranjero').on('change', function(){
            if($(this).is(':checked')){
                $('#field_tipo_documento').show();
                $('#field_pais').show();
            }else{
                $('#field_tipo_documento').hide();
                $('#field_pais').hide();
            }
        });

        $('form[name="recover"]').on('submit', (e) => {
            InputError.reset();
            $('button[type="submit"]').attr('disabled', 'disabled').addClass('disabled');

            if(!$('#field_extranjero').is(':checked')){
                $('select[name="tipo_documento"]').val('DO');
                $('select[name="cod_pais"]').val(1);
            }

            var data_form=$('form[name="recover"]').serialize();
            data_form=data_form+'&g-recaptcha-response='+self.recaptcha_token;

            $.ajax({
                url: $(e.currentTarget).attr('action'),
                type : "POST",
                dataType : 'json',
                data : data_form,
                success : (data) => {
                    $('button[type="submit"]').removeAttr('disabled').removeClass('disabled');
                    if (data.status === 1){
                        return Failed.success({
                            icon:{
                                type:'icon--success',
                                src:'ic-success-result.svg'
                            },
                            title: 'Recuperar contraseña',
                            description: 'Te enviamos un correo electrónico para que puedas modificar tu contraseña.'
                        });
                    } else if (data.status === 2){
                        return Failed.show(data.message);
                    } else if (data.status === 3){
                        window.location.href = App.baseUrl + '/panel/verificar-sms';
                    } else if (data.status === 4){
                        window.location.href = App.baseUrl + '/panel/verifica-tu-cuenta';
                    } else {
                        InputError.validate();
                        if (data.error){
                            InputError.show(data.error);
                        }
                    }
                },
                error: function(xhr, resp, text) {
                    console.log(xhr, resp, text);
                }
            });
            return false;
        });
    }

    
}

export default Recover;